<template>
  <div>
      <!-- 头部 -->
      <top></top>
      <el-row class="hidden-sm-and-up">
        <el-col>
          <div class="mineNav-left">
            <ul class="mineNav">
              <li @click="toPath('/mine')">{{$t('exhibitor.personal')}}</li>
              <li @click="show(0)">
                <p>{{$t('exhibitor.collect')}} <i class="el-icon-arrow-down"></i></p>
                <ul class="minesubnav" v-if="isSHowSub">
                  <li @click.stop="collectMChange(0)">{{$t('exhibitor.product')}}</li>
                  <li @click.stop="collectChange(1)">{{$t('exhibitor.enterprise')}}</li>
                  <li @click.stop="collectMChange(2)">{{$t('navMenu.active')}}</li>
                </ul>
              </li>
              <!-- <li @click="show(1)">
                <p>{{$t('exhibitor.demand')}} 
                  <i class="el-icon-arrow-down"></i>
                </p>
                <ul class="minesubnav"  v-if="isSHowSubDemand">
                  <li @click.stop="demandMChange(0)">{{$t('exhibitor.sendDemand')}}</li>
                  <li @click.stop="demandMChange(1)">{{$t('exhibitor.myAnswer')}}</li>
                  <li @click.stop="demandMChange(2)">{{$t('exhibitor.enterpriseMessage')}}</li>
                </ul>
              </li> -->
              <li class="active" @click="toPath('/feedback')">{{$t('exhibitor.feedback')}}</li>
              <!-- <li class="inbox" @click="toPath('/inbox')">{{$t('business.inboxs')}}</li> -->
            </ul>
          </div>
        </el-col>
      </el-row>
      <el-row class="exmain" >
        <el-col :xs="xsNumLeft" :sm="xsNumLeft" :md="3" :lg="3" :xl="4"></el-col>
        <el-col :xs="xsNumLeftNav" :sm="xsNumLeftNav" :md="5" :lg="2" :xl="2" class="hidden-sm-and-down">
          <div class="mineNav-left">
            <ul class="mineNav">
              <li @click="toPath('/mine')">{{$t('exhibitor.personal')}}</li>
              <li @click="show(0)">
                <p>{{$t('exhibitor.collect')}} <i class="el-icon-arrow-right"></i></p>
                <ul class="minesubnav" v-if="isSHowSub">
                  <li @click.stop="collectChange(0)">{{$t('exhibitor.product')}}</li>
                  <li @click.stop="collectChange(1)">{{$t('exhibitor.enterprise')}}</li>
                  <li @click.stop="collectChange(2)">{{$t('navMenu.active')}}</li>
                </ul>
              </li>
              <!-- <li @click="show(1)">
                <p>{{$t('exhibitor.demand')}} <i class="el-icon-arrow-right"></i></p>
                <ul class="minesubnav"  v-if="isSHowSubDemand">
                  <li @click.stop="demandChange(0)">{{$t('exhibitor.sendDemand')}}</li>
                  <li @click.stop="demandChange(1)">{{$t('exhibitor.myAnswer')}}</li>
                  <li @click.stop="demandChange(2)">{{$t('exhibitor.enterpriseMessage')}}</li>
                </ul>
              </li> -->
              <li @click="toPath('/feedback')" class="active">{{$t('exhibitor.feedback')}}</li>
              <!-- <li class="inbox" @click="toPath('/inbox')">{{$t('business.inboxs')}}</li> -->
            </ul>
          </div>
        </el-col>
        <el-col :xs="xsNum" :sm="xsNum" :md="14" :lg="12" :xl="10">
          <div class="main-right" :style="{minHeight:height}">
            <feedback></feedback>
          </div>
        </el-col>
        <el-col :xs="1" :sm="1" :md="3" :lg="3" :xl="4"></el-col>
      </el-row>
      <!-- 底部 -->
      <bottom></bottom>
  </div>
</template>
<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import feedback from "./components/feedback.vue";
export default {
  components: { top,  bottom, feedback},
  name: "mine",
  data() {
    return {
      isSHowSub:false,
      isSHowSubDemand:false,
      height: '',
      langSet: '',
      xsNumLeft: 1,
      xsNumLeftNav: 4,
      xsNum: 18
    }
  },
  created() {
  },
  mounted() {
    this.setHeight();
    if(this._isMobile()) {
      this.xsNumLeft = 1;
      this.xsNumLeftNav = 0;
      this.xsNum = 22;
    }else{
      this.xsNumLeft = 1;
      this.xsNumLeftNav = 4;
      this.xsNum = 18;
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    collectMChange(index){
      if(index == 0){
        this.$router.push({
          name: 'myproduct'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'mycompany'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'myactive'
        });
      }
      this.isSHowSub = !this.isSHowSub;
    },
    demandMChange(index){
      if(index == 0){
        this.$router.push({
          name: 'demandissue'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'myresponse'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'mymessage'
        });
      }
      this.isSHowSubDemand = !this.isSHowSubDemand;
    },
    setHeight(){
      this.height = window.innerHeight  - 175 + 'px';
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    toPath(path){
      this.$router.push({path});
    },
    show(id){
      if(id == 0){
        this.isSHowSub = !this.isSHowSub;
      }else{
        this.isSHowSubDemand = !this.isSHowSubDemand;
      }
    },
    collectChange(index){
      if(index == 0){
        this.$router.push({
          name: 'myproduct'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'mycompany'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'myactive'
        });
      }
    },
    demandChange(index){
      if(index == 0){
        this.$router.push({
          name: 'demandissue'
        });
      }else if(index == 1){
        this.$router.push({
          name: 'myresponse'
        });
      }else if(index == 2){
        this.$router.push({
          name: 'mymessage'
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.main{padding-top: 40px;padding-left: 184px;}
.exmain .main-right{padding-bottom: 0;}
.mineNav > li{font-size:20px;line-height:28px;color: #000;margin-bottom: 24px;cursor: pointer;width: 100px;text-align: center;}
.mineNav > li.active{color: #CAC28A;}
.mineNav > li p{position: relative;}
.mineNav > li p i{position: absolute;top: 5px;}
.mineNav > li .minesubnav{color: #666;font-size:18px;line-height: 25px;padding-bottom: 13px;text-align: center;}
.mineNav > li .minesubnav li{padding-top: 14px;}
.mineNav > li .minesubnav .active{color: #CAC28A;}

@media only screen and (max-width: 767px){
  .mineNav{
    padding: 0 0.2rem;
    display: flex;
    margin-top: 0.2rem;
    li.inbox{font-size: 11px;}
    li{
      font-size: 11px;
      flex: 1;
      position: relative;
      margin-bottom: 0;
      p i{top: 0.18rem;}
      .minesubnav{
        font-size: 11px;
        line-height: 0.25rem;
        position: absolute;
        background: #fff;
        width: 100%;
        z-index: 999;
        li{padding-top: 0.14rem;}
      }
    } 
  }
}
</style>